const ENVIRONMENTS = {
  LOCAL: 'local',
  DEVELOPMENT: 'dev',
  ORIGIN: 'origin',
  STAGING: 'staging',
  STAGING_NEW: 'staging-new',
  STAGING_QA: 'staging-QA',
  PRODUCTION: 'prod'
};

export const localPort = {
  default: 5000,
  user: 7001,
  survey: 7002,
  main: 7003,
  report: 7008,
};

const globalConfig = {
  env: ENVIRONMENTS.ORIGIN,
  LanguageDB: {
    dbName: "SSK",
    dbTable: "language",
    dbVersion: 1,
    dbCon: null,
  },
  LanguageData: null,
  LanguageUpdatedDate: null,
  API_URL: "",
  ADSSO_API_URL: "",
  ADSSO_PID:"",
  debug: true,
};

const ADSSO_PID_STAGING = "667D4895-F294-4D6F-8979-5084CB1B53A8";
const ADSSO_PID_LIVE = "FFDD35BC-225B-45AB-AF01-81AF631F80AC";

switch (globalConfig.env) {
  case ENVIRONMENTS.LOCAL:
    globalConfig.API_URL = "http://localhost:"; 
    globalConfig.ADSSO_API_URL = "http://203.254.249.221";
    globalConfig.ADSSO_PID= ADSSO_PID_STAGING;
    break;
  case ENVIRONMENTS.DEVELOPMENT:
    globalConfig.API_URL = "http://107.10.89.196/newssk";
    globalConfig.ADSSO_API_URL = "http://107.10.89.196";
    globalConfig.ADSSO_PID= ADSSO_PID_STAGING;
    break;
  case ENVIRONMENTS.STAGING:
    globalConfig.API_URL = "https://samsungmcs.site/newmcs";
    globalConfig.ADSSO_API_URL = "https://samsungmcs.site";
    globalConfig.ADSSO_PID= ADSSO_PID_STAGING;
    break;
  case ENVIRONMENTS.STAGING_QA:
      globalConfig.API_URL = "https://samsungmcs.site/newmcsqa";
      globalConfig.ADSSO_API_URL = "https://samsungmcs.site";
      globalConfig.ADSSO_PID= ADSSO_PID_STAGING;
      break;
  case ENVIRONMENTS.PRODUCTION:
    globalConfig.API_URL = "https://scsi.sec.samsung.net/newmcs";
    globalConfig.ADSSO_API_URL = "https://scsi.sec.samsung.net";
    globalConfig.ADSSO_PID= ADSSO_PID_LIVE;
    break;
  case ENVIRONMENTS.STAGING_NEW:
    globalConfig.API_URL = "https://samsungmcs.site/NewMCSStaging";
    globalConfig.ADSSO_API_URL = "https://samsungmcs.site";
    globalConfig.ADSSO_PID= ADSSO_PID_STAGING;
    // globalConfig.API_URL = "https://staging-seao.sec.samsung.net:8443/NewMCS";
    // globalConfig.ADSSO_API_URL = "https://staging-seao.sec.samsung.net:8443";
    break;
  case ENVIRONMENTS.ORIGIN:
    globalConfig.API_URL = location.origin + location.pathname.slice(0, location.pathname.length - 1);
    globalConfig.ADSSO_API_URL = location.origin;
    if (location.origin === 'https://scsi.sec.samsung.net') {
      globalConfig.ADSSO_PID = ADSSO_PID_LIVE;
    } else if (location.origin === 'https://samsungmcs.site') {
      globalConfig.ADSSO_PID = ADSSO_PID_STAGING;
    }

    break;
}

export default globalConfig;

export const apiStatusCodes = {
  ok: 200,
  created: 201,
  noContent: 204,
  badRequest: 400,
  unauthorized: 401,
  forbidden: 403,
  notFound: 404,
  serverError: 500,
};

export const countryId = {
  Australia: 1,
  Indonesia: 2,
  Cambodia: 3,
  Laos: 4,
  Myanmar: 5,
  Malaysia: 6,
  NewZealand: 7,
  Philippines: 8,
  Singapore: 9,
  Thailand: 10,
  Vietnam: 11,
};

export const transStatus = {
  success: "SUCCESS",
  failed: "FAILED",
  validationError: "VALIDATION_ERROR",
  forbid: "FORBID",
  unauthorized: "UNAUTHORIZED",
};

export const AMCHARTS5_LICENSE = "AM5C346622369";

export const FLEXMONSTER_LICENSE = location.origin === "https://scsi.sec.samsung.net"
? 'Z76T-XH601E-0S6K02-3V1H09-6U4R67-48344N-186C5T-256Y4W-463C2A-2Z4T6S' : location.origin === "https://samsungmcs.site" ? 'Z7K0-XHGG5F-101U5L-5G5L3B-23490Y-3P1Y2D-5S194B-613S0M-6K6D5E-53'
: 'Z7E9-XGG51W-2Z5O06-20154D-723H6O-2T2R0V-020L44-2C4W6X-5D143O-6H451H';

export const WIDGET_STATUS = {
  ACTIVE: "001",
  INACTIVE: "002",
};
